import { render } from "./BaseText.vue?vue&type=template&id=aad5d40e&ts=true"
import script from "./BaseText.vue?vue&type=script&lang=ts"
export * from "./BaseText.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__